import { useQueryClient } from '@tanstack/react-query';
import { useApplicationLocalStorage } from '../../application-hook';
import { LumenApplicationParameters } from '@platform/client/schemas';
import { useState } from 'react';
import { ApplicationPageProps } from '../../Application';
import { Application, Cohorts } from '@platform/client';
import { CohortDetails } from '../../program/shared/CohortDetails';
import { ErrorBox } from '@platform/components';

export const LumenConfirmAndSubmit = (props: ApplicationPageProps) => {
	const [failed, setFailed] = useState(false);
	const { getApplicationData } = useApplicationLocalStorage<LumenApplicationParameters>(
		props.dataKey,
	);
	const { data: cohortData, isSuccess } = Cohorts.useGetCurrentUserCurrentCohort();
	const submitLumenMutation = Application.useSubmitLumenApplication();
	const queryClient = useQueryClient();

	const submit = () => {
		submitLumenMutation.mutate(
			{
				data: {
					...getApplicationData(),
				},
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: Application.getGetProfessionalApplicationStatusQueryKey(),
					});
				},
				onError: () => {
					setFailed(true);
				},
			},
		);
	};

	return (
		<>
			{isSuccess && cohortData && <CohortDetails {...props} cohortData={cohortData} onSubmit={submit} onBack={props.onBack} />}
			{failed && (
				<ErrorBox showAlertTriangle={true}>
					There was an error submitting your application. Please try again later.
				</ErrorBox>
			)}
		</>
	);
};
